/* @refresh reload */
import "@fontsource-variable/manrope";
import "@fontsource-variable/bricolage-grotesque";

import { render } from "solid-js/web";
import { App } from "./App";
import { applyStoredTheme } from "./features/theme/apply";
import "./styles/global.css";

applyStoredTheme();

if (import.meta.env.DEV && "serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) =>
      Promise.all(registrations.map((registration) => registration.unregister()))
    )
    .catch(() => {
      // Best-effort cleanup: a stale service worker must not block local dev.
    });
}

const root = document.getElementById("root");
if (!root) throw new Error("#root not found in index.html");

render(() => <App />, root);
